'use client';

import { ReactNode, Ref, forwardRef, useEffect, useRef, useState } from "react";
import { Swiper as SwiperJS, SwiperProps, SwiperSlideProps } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { twMerge } from 'tailwind-merge';

interface Props {
  slides: ReactNode[];
  className?: string;
  wrapperClassName?: string;
  swiperProps?: Partial<SwiperProps>;
  swiperSlideProps?: Partial<SwiperSlideProps>;
}

const SwiperFour = forwardRef(({ slides, className, wrapperClassName, swiperProps, swiperSlideProps }: Props, ref: any) => {
  return (
    <div className={twMerge('flex flex-col w-full h-full gap-y-[35px] desktop:gap-y-0 desktop:px-0 relative', wrapperClassName)}>
      <SwiperJS
        slidesPerView='auto'
        {...swiperProps}

        breakpoints={{
          0: {
            // slidesPerView: 1.5
          },
          768: {
            // slidesPerView: 3.15
          },
          1024: {
            // slidesPerView: 5,
            enabled: false
          }
        }}

        className={twMerge('w-full !relative', swiperProps?.className)}
        wrapperClass={twMerge(className)}
        ref={ref}
      >
        {slides.map((s, i) => <SwiperSlide key={i} {...swiperSlideProps} className={twMerge('pl-[16px] h-full', swiperSlideProps?.className)}>{s}</SwiperSlide>)}
      </SwiperJS>
 </div>

)
});


export default SwiperFour;